import React, { Suspense, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ROUTES } from 'shared-ui/utils/constants'
import { InviteRouteGuard } from './InviteRouteGuard.jsx'
import Terms from '../pages/Terms/index.jsx'
import Privacy from '../pages/Privacy/index.jsx'
import CreatorHomeImageListPage from '../pages/Reels/CreatorHomeImageListPage.jsx'
import DashboardImageList from '../pages/Reels/DashboardImageList.jsx'
import {  Loader } from 'shared-ui/components'
// Lazy-loaded components
const SuperAppHomeImageListPage = lazy(
  () => import('../pages/Reels/SuperAppHomeImageListPage.jsx')
)
const SelectTemplatePage = lazy(
  () => import('../pages/Create/DesktopView/SelectTemplate.jsx')
)
const AccountCreationSuccess = lazy(
  () => import('../pages/Login/AccountCreationSuccess.jsx')
)
const ImageList = lazy(() => import('../pages/Reels/ImageList.jsx'))
const CreateReelsPage = lazy(() => import('../pages/Reels/CreateReelsPage.jsx'))
const ReelsPage = lazy(() => import('../pages/Reels/ReelsPage.jsx'))
const TalkingAvatarLanding = lazy(
  () => import('../pages/Create/TalkingAvatar/TalkingAvatarLanding.jsx')
)
// const Eternal = lazy(() => import('@eternal-app/remoteWrapper'))
const Eternal = lazy(() => import('../pages/EternalPage.js'))

const VoiceCloneLanding = lazy(
  () => import('../pages/VoiceCloning/VoiceCloneLanding/VoiceCloneLanding.jsx')
)
const VoiceLibrary = lazy(
  () => import('../pages/VoiceCloning/VoiceLibrary/VoiceLibrary.jsx')
)
const VoiceRecorder = lazy(
  () => import('../pages/VoiceCloning/VoiceRecorder/VoiceRecorder.jsx')
)
const EditVoiceClone = lazy(
  () => import('../pages/VoiceCloning/EditVoiceClone/EditVoiceClone.jsx')
)
const SubscriptionHistory = lazy(
  () => import('../pages/Subscription/SubscriptionHistory.jsx')
)
const Splash = lazy(() => import('shared-ui/components/splash/index.jsx'))
const ViewCardModal = lazy(() => import('shared-ui/components/UserProfile/UserDashboardComponents/ViewCardModal.jsx'))
const Welcome = lazy(() => import('../pages/WaitList/Welcome/Welcome.jsx'))
const Landing = lazy(() => import('../pages/WaitList/Landing/Landing.jsx'))
const WaitListLogin = lazy(
  () => import('../pages/WaitList/WaitListLogin/WaitListLogin.jsx')
)
const WaitListOTP = lazy(
  () => import('../pages/WaitList/WaitListOTP/WaitListOTP.jsx')
)
const WaitListSuccess = lazy(
  () =>
    import('../pages/WaitList/WaitListOTP/WaitListSuccess/WaitListSuccess.jsx')
)
const WaitListInvite = lazy(
  () => import('../pages/WaitList/WaitListInvite/WaitListInvite.jsx')
)
const CreatorList = lazy(() => import('shared-ui/components/CreatorList'))
const FollowerList = lazy(() => import('shared-ui/components/FollowerList'))
const BlockUserList = lazy(() => import('shared-ui/components/BlockUserList'))
const Home = lazy(() => import('../pages/Home'))
const loadLogin = () => import('../pages/Login/login.jsx')
const Login = lazy(loadLogin)
const Output = lazy(() => import('../pages/Create/Output/index.jsx'))
const PhotoGallery = lazy(() => import('../pages/Create/Gallery/index.jsx'))
const Player = lazy(() => import('../pages/Player/index.jsx'))
const Register = lazy(() => import('../pages/Login/register.jsx'))
const SelectSource = lazy(
  () => import('../pages/Create/SelectSource/index.jsx')
)
const Settings = lazy(() => import('../pages/Setting/index.jsx'))
const Theme = lazy(() => import('../pages/Setting/ThemePage.jsx'))
const Language = lazy(() => import('../pages/Setting/LanguagePage.jsx'))
const ConsentPermissions = lazy(
  () => import('../pages/Setting/ConsentPermissions.jsx')
)

const NotificationPage = lazy(
  () => import('../pages/Setting/NotificationPage.jsx')
)
const UpdateEmail = lazy(() => import('../pages/Setting/UpdateEmail.jsx'))
const UpdatePassword = lazy(() => import('../pages/Setting/UpdatePassword.jsx'))
const Create = lazy(() => import('../pages/Create/index.jsx'))
const Studio = lazy(() => import('../pages/Create/Studio/index.jsx'))
const Profile = lazy(() => import('../pages/Profile/index.jsx'))
const ExploreGallery = lazy(() => import('../pages/ExploreGallery/index.jsx'))
const Discover = lazy(() => import('../pages/Discover/index.jsx'))
const ContentDetail = lazy(() => import('../pages/Discover/ContentDetail.jsx'))
const ListPage = lazy(() => import('../pages/ListPage/index.jsx'))
const ForgotPassword = lazy(() => import('../pages/Login/forgotPwd.jsx'))
const OtpVarification = lazy(() => import('../pages/Login/otpVarification.jsx'))
const NewPassword = lazy(() => import('../pages/Login/newPassword.jsx'))
const ResetPassword = lazy(() => import('../pages/Login/resetPwd.jsx'))
const LinkSent = lazy(() => import('../pages/Login/linkSent.jsx'))
const PasswordSuccess = lazy(() => import('../pages/Login/PasswordSuccess.jsx'))
const VerifyEmail = lazy(() => import('../pages/Login/verifyEmail.jsx'))
const Creator = lazy(() => import('../pages/Profile/Creator.jsx'))
const FAQ = lazy(() => import('../pages/FAQ/index.jsx'))
const EditProfile = lazy(() => import('../pages/Profile/EditProfile.jsx'))
const SelectBackground = lazy(
  () => import('../pages/Create/SelectBackground/index.jsx')
)
const Dashboard = lazy(() => import('../pages/Dashboard/index.jsx'))
const DashboardFilter = lazy(() => import('../pages/Dashboard/FilterPage.jsx'))
const PopularTools = lazy(() => import('../pages/PopularTools/index.jsx'))
// const ColorModeEnhance = lazy(
//   () => import('../pages/Create/ColorModeEnhance/index.jsx')
// )
const ColorModeEnhance = lazy(
  () => import('../pages/Create/Colorize/index.jsx')
)
const Gender = lazy(() => import('../pages/Gender/index.jsx'))
const Country = lazy(() => import('../pages/Country/index.jsx'))
const Saved = lazy(() => import('../pages/Saved/index.jsx'))
const PasswordUpdated = lazy(() => import('../pages/Login/PasswordUpdated.jsx'))
const VerifySignup = lazy(() => import('../pages/Login/VerifySignup.jsx'))
const Logout = lazy(() => import('../pages/Login/logout.jsx'))
const DeleteAccount = lazy(() => import('../pages/Login/deleteAccount.jsx'))
const SubmitFeedback = lazy(() => import('../pages/Feedback/index.jsx'))
const FeedbackTypeSelect = lazy(
  () => import('../pages/Feedback/TypeSelect.jsx')
)
const ReportProblem = lazy(() => import('../pages/Report/index.jsx'))
const DeleteAccountPage = lazy(() => import('../pages/DeleteAccount/index.jsx'))
const Search = lazy(() => import('../pages/Search/index.jsx'))
const Wallet = lazy(() => import('../pages/Wallet/myWallet.jsx'))
const Rewards = lazy(() => import('../pages/Wallet/rewards.jsx'))
const EarnCoin = lazy(() => import('../pages/Wallet/earnCoin.jsx'))
const Transaction = lazy(() => import('../pages/Wallet/transaction.jsx'))
const RewardSelect = lazy(() => import('../pages/Wallet/rewardSelect.jsx'))

const Subscription = lazy(() => import('../pages/Subscription/index.jsx'))
const Payment = lazy(() => import('../pages/Subscription/Payment.jsx'))
const UpdatedPayment = lazy(
  () => import('../pages/Subscription/UpdatedPayment.jsx')
)
const PaymentActivation = lazy(
  () => import('../pages/Subscription/paymentActivation.jsx')
)
const PaymentFailed = lazy(
  () => import('../pages/Subscription/paymentFailed.jsx')
)
const UpdatePromo = lazy(() => import('../pages/Subscription/updatePromo.jsx'))
const SubscriptionSettingPlan = lazy(
  () => import('../pages/Subscription/SubscriptionSettingPlan.jsx')
)
const Notification = lazy(() => import('../pages/Notification/index.jsx'))
const FilterNotification = lazy(
  () => import('../pages/Notification/FilterNotification.jsx')
)
const StripeWrapper = lazy(
  () => import('../pages/Subscription/StripePay/paymentPage.jsx')
)
const AvtarPicker = lazy(() => import('../pages/AvatarSelection/index.jsx'))
const FilterTransaction = lazy(
  () => import('../pages/Wallet/filterTransaction.jsx')
)
const CancleSubscription = lazy(
  () => import('../pages/Subscription/cancleSubscription.jsx')
)
const HowItWorks = lazy(
  () => import('shared-ui/components/HowItWork/index.jsx')
)
const SearchBar = lazy(() => import('../pages/ScarchScreen/index.jsx'))
const loadSuperAppHome = () => import('../pages/SuperAppHome/index.jsx')
const SuperAppHome = lazy(loadSuperAppHome)
const preloadOnEntry = { [ROUTES.sAppHome]: loadSuperAppHome, [ROUTES.login]: loadLogin }
preloadOnEntry[window.location.pathname]?.().catch(() => {
  // lazy() retries the import and reports a real failure when the route renders
})
const ChatGptScreen = lazy(
  () => import('../pages/ChatGptScreen/ChatGptScreen.jsx')
)
const TextToImage = lazy(() => import('../pages/Create/TextToImage/index.jsx'))
const TextToVideo = lazy(() => import('../pages/Create/TextToVideo/index.jsx'))
const ImageToVideo = lazy(
  () => import('../pages/Create/ImageToVideo/index.jsx')
)
const VoiceRemix = lazy(() => import('../pages/Create/VoiceRemix/index.jsx'))
const ActionGeneration = lazy(
  () => import('../pages/Create/ActionGeneration/index.jsx')
)
const PlayListScreen = lazy(() => import('../pages/PlayListScreen/index.jsx'))
const HashtagScreen = lazy(() => import('../pages/HashtagsScreen/index.jsx'))
const PostListScreen = lazy(() => import('../pages/PostScreen/index.jsx'))
const Audio = lazy(() => import('../pages/Audio/Audio.jsx'))
const AudioPreview = lazy(() => import('shared-ui/components/AudioPreview'))
const MotionControl = lazy(() => import('../pages/Create/MotionControl/index.jsx'))
const SelectMotionVideo = lazy(() => import('../pages/Create/MotionControl/SelectVideo.jsx'))
const MoreSearchResult = lazy(() => import('../pages/ScarchScreen/SearchResults.jsx'))
const CreativeEditor = lazy(() => import('../pages/Create/CreativeEditor/index.jsx'))
const ModerationPage = lazy(() => import('../pages/Create/Moderation/index.jsx'))
const AppRoutes = () => {
  const routes = [
    // { path: ROUTES.home, element: isAuthenticated ? <SuperAppHome /> : <Login /> },
    { path: ROUTES.login, element: <Login /> },
    { path: '/super-app-home', element: <SuperAppHome /> },
    { path: '/home', element: <Home /> },
    { path: ROUTES.terms, element: <Terms /> },
    { path: ROUTES.privacy, element: <Privacy /> },
    { path: '/register', element: <Register /> },
    { path: '/player', element: <Player /> },
    { path: '/setting', element: <Settings /> },
    { path: '/setting/update-email', element: <UpdateEmail /> },
    { path: '/setting/update-password', element: <UpdatePassword /> },
    { path: ROUTES.notification, element: <NotificationPage /> },
    { path: ROUTES.theme_options, element: <Theme /> },
    { path: ROUTES.langauge_options, element: <Language /> },
    { path: ROUTES.consent, element: <ConsentPermissions /> },
    { path: '/source', element: <SelectSource /> },
    { path: ROUTES.studio, element: <Studio /> },
    { path: '/gallery/:query', element: <PhotoGallery /> },
    { path: '/output', element: <Output /> },
    { path: '/content/:id', element: <ContentDetail /> },
    { path: '/reels/:contentId', element: <ReelsPage /> },
    { path: '/explore-gallery/:category', element: <ExploreGallery /> },
    { path: ROUTES.discover, element: <Discover /> },
    { path: '/profile', element: <Profile /> },
    { path: '/forgotPwd', element: <ForgotPassword /> },
    { path: '/otpVerification', element: <OtpVarification /> },
    { path: '/newPassword', element: <NewPassword /> },
    { path: '/resetPwd', element: <ResetPassword /> },
    { path: '/linkSent', element: <LinkSent /> },
    { path: '/passwordSuccess', element: <PasswordSuccess /> },
    { path: '/verifyEmail', element: <VerifyEmail /> },
    { path: '/pswUpdated', element: <PasswordUpdated /> },
    { path: '/verifySignup', element: <VerifySignup /> },
    { path: '/creatorList', element: <CreatorList /> },
    { path: '/creator/:id', element: <Creator /> },
    { path: '/faq', element: <FAQ /> },
    { path: '/FollowerList', element: <FollowerList /> },
    { path: ROUTES.blockedUserList, element: <BlockUserList /> },
    { path: '/editProfile', element: <EditProfile /> },
    { path: '/dashboard', element: <Dashboard /> },
    { path: ROUTES.dashboardFilter, element: <DashboardFilter /> },
    { path: ROUTES.aiDashboard, element: <Dashboard /> },
    { path: '/selectTemplate', element: <SelectTemplatePage /> },
    { path: '/selectBackground', element: <SelectBackground /> },
    { path: '/create', element: <PopularTools /> },
    { path: '/colorChange', element: <ColorModeEnhance /> },
    // { path: '/imageEnhance', element: <Create /> },
    { path: ROUTES.faceSwap, element: <Create /> },
    { path: ROUTES.colorize, element: <Create /> },
    { path: ROUTES.sceneSwap, element: <Create /> },
    { path: '/gender', element: <Gender /> },
    { path: '/country', element: <Country /> },
    { path: '/saved', element: <Saved /> },
    { path: '/logout', element: <Logout /> },
    { path: ROUTES.deleteAccount, element: <DeleteAccount /> },
    { path: '/feedback', element: <SubmitFeedback /> },
    { path: '/feedback/type', element: <FeedbackTypeSelect /> },
    { path: '/report', element: <ReportProblem /> },
    { path: '/delete-account', element: <DeleteAccountPage /> },
    { path: '/:pageName', element: <ListPage /> },
    { path: '/search', element: <Search /> },
    { path: ROUTES.wallet, element: <Wallet /> },
    { path: ROUTES.earnCoin, element: <EarnCoin /> },
    { path: ROUTES.rewards, element: <Rewards /> },
    { path: ROUTES.rewardSelect, element: <RewardSelect /> },
    { path: ROUTES.transactions, element: <Transaction /> },
    { path: ROUTES.search, element: <Search /> },
    { path: ROUTES.notifications, element: <Notification /> },
    { path: '/avtar', element: <AvtarPicker /> },
    { path: ROUTES.filterTransaction, element: <FilterTransaction /> },
    { path: ROUTES.subscription, element: <Subscription /> },
    { path: ROUTES.subscriptionHistory, element: <SubscriptionHistory /> },
    { path: ROUTES.payment, element: <Payment /> },
    { path: '/updatedPayment', element: <UpdatedPayment /> },
    {
      path: ROUTES.subscriptionSettingPlan,
      element: <SubscriptionSettingPlan />
    },
    { path: ROUTES.paymentActivation, element: <PaymentActivation /> },
    { path: ROUTES.paymentFailed, element: <PaymentFailed /> },
    { path: ROUTES.updatePromo, element: <UpdatePromo /> },
    { path: ROUTES.notifications, element: <Notification /> },
    { path: ROUTES.cardDetail, element: <StripeWrapper /> },
    { path: ROUTES.search, element: <Search /> },
    { path: '/notifications/filter', element: <FilterNotification /> },
    { path: '/avtar', element: <AvtarPicker /> },
    { path: ROUTES.cancleSubscription, element: <CancleSubscription /> },
    { path: '/howItWorks', element: <HowItWorks /> },
    { path: ROUTES.textToImage, element: <TextToImage /> },
    { path: ROUTES.textToVideo, element: <TextToVideo /> },
    { path: ROUTES.imageToVideo, element: <ImageToVideo /> },
    { path: ROUTES.voiceRemix, element: <VoiceRemix /> },
    { path: ROUTES.waitListWelcome, element: <Welcome /> },
    { path: ROUTES.waitListLanding, element: <Landing /> },
    { path: ROUTES.waitListLogIn, element: <WaitListLogin /> },
    { path: ROUTES.waitListOTP, element: <WaitListOTP /> },
    { path: ROUTES.waitListSuccess, element: <WaitListSuccess /> },
    { path: ROUTES.waitListInvite, element: <WaitListInvite /> },
    { path: ROUTES.splash, element: <Splash /> },
    { path: ROUTES.sSearch, element: <SearchBar /> },
    { path: ROUTES.erosAi, element: <ChatGptScreen /> },
    { path: ROUTES.eternal, element: <Eternal /> },
    { path: ROUTES.voiceCloneLanding, element: <VoiceCloneLanding /> },
    { path: ROUTES.voiceLibrary, element: <VoiceLibrary /> },
    { path: ROUTES.voiceRecorder, element: <VoiceRecorder /> },
    { path: ROUTES.editVoiceClone, element: <EditVoiceClone /> },
    { path: ROUTES.talkingAvatarLanding, element: <TalkingAvatarLanding /> },
    { path: ROUTES.actionGeneration, element: <ActionGeneration /> },
    { path: ROUTES.createReels, element: <CreateReelsPage /> },
    { path: ROUTES.imageList, element: <ImageList /> },
    {
      path: ROUTES.accountCreationSuccess,
      element: <AccountCreationSuccess />
    },
    { path: '/playerList', element: <PlayListScreen /> },
    { path: '/postList', element: <PostListScreen /> },
    { path: '/hashTags', element: <HashtagScreen /> },
    { path: '/searchResults', element: <MoreSearchResult /> },
    { path: ROUTES.audioPreviewList, element: <Audio /> },
    { path: ROUTES.audioPreview, element: <AudioPreview /> },
    { path: ROUTES.motionControl, element: <MotionControl /> },
    { path: '/ai-tool/motion-control', element: <MotionControl /> },
    { path: '/motion-control/select-video', element: <SelectMotionVideo /> },
    { path: ROUTES.creativeEditor, element: <CreativeEditor /> },
    { path: ROUTES.moderation, element: <ModerationPage /> },
    { path: ROUTES.superAppImageList, element: <SuperAppHomeImageListPage /> },
    { path: ROUTES.creatorAppImageList, element: <CreatorHomeImageListPage /> },
    {path :'/viewCard',element:<ViewCardModal/>},
    {
      path: ROUTES.dashboardImageList,
      element: (
        <DashboardImageList />
      )
    },

  ]

  return (
    <Suspense fallback={<Loader />}>
      <InviteRouteGuard>
        <Routes>
          {routes.map(({ path, element }, index) => (
            <Route key={path ? `${path}-${index}` : index} path={path}
              element={element} />
          ))}
        </Routes>
      </InviteRouteGuard>
    </Suspense>
  )
}

export default AppRoutes
